"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-item-container" };
const _hoisted_2 = {
    key: 0,
    class: "card-res-amount"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
    key: 1,
    class: "card-over"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.item.showDigit)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.amountAbs), 1))
            : (0, vue_1.createCommentVNode)("", true),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.itemsToShow, (index) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                class: (0, vue_1.normalizeClass)(_ctx.componentClasses),
                innerHTML: _ctx.itemHtmlContent,
                key: index
            }, null, 10, _hoisted_3));
        }), 128)),
        (_ctx.item.over !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, "over " + (0, vue_1.toDisplayString)(_ctx.item.over), 1))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
